module.exports = __webpack_public_path__ + "static/media/migration-icon.a75edc4c.svg";